
interface ConfigType {
    environment: 'development'|'production';
    app: {
        version: string;
        name: string;
    };
    keycloak: {
        baseUrl: string;
        realm: string;
        clientId: string;
        staticUser?: {
            [key: string]: {
                username: string;
                password: string;
            };
        };
    };

    api: {
        baseUrl: string;
    };
}

const Config: ConfigType = {
    environment: process.env.REACT_APP_ENV! as 'development'|'production',
    app: {
        version: process.env.REACT_APP_VERSION!,
        name: process.env.REACT_APP_NAME!,
    },
    keycloak: {
        baseUrl: process.env.REACT_APP_KC_BASE_URL!,
        realm: process.env.REACT_APP_KC_REALM!,
        clientId: process.env.REACT_APP_KC_CLIENT_ID!,
        staticUser: process.env.REACT_APP_KC_STATIC_USER
            ? JSON.parse(process.env.REACT_APP_KC_STATIC_USER)
            : [],
    },

    api: {
        baseUrl: window.location.origin + '/api',
    },
};

export default Config;
